import { slice } from './slice'

const whiteboardActions = {
  ...slice.actions,
}

export default whiteboardActions
